export function setCookie__c(cookieName, cookieValue, cookieLifespan, shareDomain = '') {
    var d = new Date(cookieLifespan);
    var expires = "expires=" + d.toUTCString() + ";";
    var domain = "domain=" + shareDomain + ";";
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + "path=/;" + "SameSite=Strict;" + domain;
}

export function getCookie__c(cookieName) {
    var name = cookieName + "=";
    var cookieArray = document.cookie.split(';'); //Split the site cookie string into an array
    for(var i = 0; i < cookieArray.length; i++){ //For every cookie in the site cookie string
        var cookie = cookieArray[i];
        while(cookie.charAt(0) == ' '){ //Remove the space from the start of the cookie name
            cookie = cookie.substring(1);
        }
        if(cookie.indexOf(name) == 0){
            return cookie.substring(name.length, cookie.length); //Return the value of the cookie
        }
    }
    return false; //Return false if there were no matching cookies
}

export function checkCookie__c(cookieName) {
    return document.cookie.indexOf(cookieName + "=") != -1; //Return true if the requested cookie name exists in the document
}

export function checkCookieStorage__c(cookieName) {
    return !!window.localStorage.getItem(cookieName)
}

export function clearCookie__c(cookieName) {
    setCookie__c(cookieName, "", -1); //Cause the browser to remove the cookie by setting its date in the past.
}